import { VisibilityOffIcon, VisibilityOnIcon } from 'components/icons';
import { Box } from '@mui/material';
import React, { forwardRef, ReactElement, useState } from 'react';
import { TextInput, TextInputProps } from '../TextInput';

export interface PasswordInputProps extends TextInputProps {}

export const PasswordInput = forwardRef(
  (
    { ...textInputProps }: PasswordInputProps,
    ref?: React.Ref<HTMLInputElement>,
  ): ReactElement => {
    const { hasError } = textInputProps;

    const [isShowing, setShowing] = useState(false);

    return (
      <Box className="PasswordInput">
        <TextInput
          {...textInputProps}
          type={isShowing ? 'text' : 'password'}
          ref={ref}
        >
          <Box
            position="absolute"
            top={0}
            bottom={0}
            left={0}
            paddingX={15}
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              borderRight: theme => `1px solid ${theme.palette.neutral.dark}`,
              cursor: 'pointer',
              userSelect: 'none',
              fontSize: '1.2em',
              borderRightColor: theme =>
                hasError
                  ? theme.palette.error.light
                  : theme.palette.neutral.dark,
            }}
            onClick={() => setShowing(!isShowing)}
          >
            {isShowing ? <VisibilityOffIcon /> : <VisibilityOnIcon />}
          </Box>
        </TextInput>
      </Box>
    );
  },
);
